import { combineReducers } from 'redux';

import UploadMaterilPage from './uploadMaterilPage'
import troubleShooting from './troubleShooting'
import projectManagement from './projectManagement'

import Login from './login'

import {routerReducer} from 'react-router-redux'


const index = combineReducers({
    routing: routerReducer,
    Login:Login,
    UploadMaterilPage:UploadMaterilPage,
    troubleShooting:troubleShooting,
    projectManagement:projectManagement
});

export default index;